import { useSLAs } from './use-slas';

export type UseSLAByIssueTypeAndIssueSubtypeParams = {
  issueType: string;
  issueSubtype?: string;
};

export function useSLAsByIssueTypeAndIssueSubtype({
  issueType,
  issueSubtype,
}: UseSLAByIssueTypeAndIssueSubtypeParams) {
  const slas = useSLAs({
    filter: {
      issueType,
      issueSubtype,
    },
    enabled: !!issueType,
  });

  return {
    isLoading: slas.isLoading,
    data: slas.data?.data ?? [],
    isFetching: slas.isFetching,
  };
}
